export default function Events() {
  const events = [
    {
      id: 1,
      title: "Summer BBQ Fundraiser",
      description: "Join us for a community BBQ! All proceeds go to local food banks.",
      image: "https://images.stockcake.com/public/f/b/5/fb5de01a-8ba0-443f-9bd7-7302e1289cc8_large/summer-bbq-party-stockcake.jpg",
    },
    {
      id: 2,
      title: "Parade",
      description: "Celebrate  heritage!",
      image: "https://media.istockphoto.com/id/1133287573/photo/the-92th-annual-macys-thanksgiving-day-parade.jpg?s=612x612&w=0&k=20&c=Y5RLo97ZtYxfMdUMsCXSoqaf1GWuONrnZSE6Tiq8WWc=",
    },
    {
      id: 3,
      title: "Cancer Awareness",
      description: "Raise awareness for breast cancer, all proceeds go to charity.",
      image: "https://thumbs.dreamstime.com/b/breast-cancer-awareness-pink-ribbon-text-collage-design-cloud-shape-cause-related-words-eps-vector-file-59053018.jpg",
    },
  ]

  return (
    <main className="min-h-screen py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-3">Community Events</h1>
          <p className="text-lg text-gray-600">Join us for exciting events at your local supermarket!</p>
        </div>

        {/* Events Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {events.map((event) => (
            <div
              key={event.id}
              className="bg-white rounded-lg border border-gray-200 overflow-hidden hover:shadow-lg transition-shadow"
            >
              {/* Event Image */}
              <div className="relative h-48 bg-gray-100 overflow-hidden">
                <img src={event.image || "/placeholder.svg"} alt={event.title} className="w-full h-full object-cover" />
                
              </div>

              {/* Event Content */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">{event.title}</h3>

                

                <p className="text-gray-700 text-sm mb-4">{event.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </main>
  )
}